import joinUrl from 'url-join';
import { DebugLog } from 'common/js/debug-log';
import ajaxPromises from 'common/js/AjaxPromises';
import globalConfig from 'common/js/config';
import { generateUrlWithRegion } from 'common/js/url-utils';
import { PayloadDatas } from '../../types';
import { CreativeTagEvent } from '../../enums';
import { PayloadBuilderStrategy } from '../../payload-builder-strategies/payload-builder-strategy';

export class CreativeTrackingService {
  private allreadySentEvents: {
    [key in CreativeTagEvent]?: boolean;
  } = {
    [CreativeTagEvent.CREATIVE_LOADING_FAILED]: false
  };

  constructor(
    private readonly payloadBuilderStrategy: PayloadBuilderStrategy
  ) {}

  async sendCreativeTagTracking(
    creativeTagEvent: CreativeTagEvent,
    payload?: PayloadDatas,
    evt?: CustomEvent
  ): Promise<void> {
    if (
      this.allreadySentEvents[creativeTagEvent] !== undefined &&
      this.allreadySentEvents[creativeTagEvent]
    ) {
      return;
    }

    const eventPayload = this.payloadBuilderStrategy.buildPayload(
      creativeTagEvent,
      payload,
      evt
    );
    DebugLog.log('Creative-tag track: ' + eventPayload.event, { eventPayload });

    const baseUrl = joinUrl(
      generateUrlWithRegion(globalConfig.MS_ADS_MONITORING_EVENTS_URL),
      'ocs'
    );

    const queryParts: string[] = [];

    Object.entries(eventPayload).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        let strValue: string;
        if (typeof value === 'object' && !Array.isArray(value)) {
          strValue = encodeURIComponent(JSON.stringify(value));
        } else {
          strValue = encodeURIComponent(String(value));
        }
        queryParts.push(`${encodeURIComponent(key)}=${strValue}`);
      }
    });
    const urlWithParams = `${baseUrl}?${queryParts.join('&')}`;

    if (this.allreadySentEvents[creativeTagEvent] !== undefined) {
      this.allreadySentEvents[creativeTagEvent] = true;
    }

    return ajaxPromises.get(urlWithParams).catch(console.error);
  }
}
